// Shared icon components used by both the topbar (app.tsx) and blob
// loading states (categories.tsx).

import { useId } from "react";

const _BW = [0.83, 0.44, 0.71, 0.95, 0.33, 0.67, 0.89, 0.56];

// Unique per-instance gradient/filter ids -- two BrandIcons can be mounted
// at once (topbar Brand + a BlobLoading pulse), and duplicate SVG ids
// collide in the DOM.
export function BrandIcon() {
  const uid = useId();
  const gradId = `wb-lg-${uid}`;
  const glowId = `wb-glow-${uid}`;
  const rowH = 200 / _BW.length;
  const bh = rowH - 3;
  return (
    <svg className="brand-icon" viewBox="0 0 200 200" aria-hidden="true">
      <defs>
        <linearGradient id={gradId} x1="0" y1="1" x2="0" y2="0">
          <stop offset="0" stopColor="#c4f24a" />
          <stop offset="0.45" stopColor="#25e0c0" />
          <stop offset="1" stopColor="#ff43c8" />
        </linearGradient>
        <filter id={glowId}>
          <feGaussianBlur stdDeviation="3.5" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g opacity="0.82" fill={`url(#${gradId})`} filter={`url(#${glowId})`}>
        {_BW.map((w, i) => (
          <rect key={i} x="10" y={i * rowH + 1.5} width={w * 180} height={bh} rx="1" />
        ))}
      </g>
      <line
        x1="100"
        y1="150"
        x2="100"
        y2="174"
        stroke="#c4f24a"
        strokeWidth="6"
        strokeLinecap="round"
      />
      <path
        d="M0 0 C 14 -30 10.08 -80 0 -100 C -10.08 -80 -14 -30 0 0 Z"
        transform="translate(100 150) rotate(0)"
        fill="#c4f24a"
      />
      <path
        d="M0 0 C 12 -22.5 8.64 -60 0 -75 C -8.64 -60 -12 -22.5 0 0 Z"
        transform="translate(100 150) rotate(31)"
        fill="#c4f24a"
      />
      <path
        d="M0 0 C 12 -22.5 8.64 -60 0 -75 C -8.64 -60 -12 -22.5 0 0 Z"
        transform="translate(100 150) rotate(-31)"
        fill="#c4f24a"
      />
      <path
        d="M0 0 C 10 -19.2 7.2 -51.2 0 -64 C -7.2 -51.2 -10 -19.2 0 0 Z"
        transform="translate(100 150) rotate(61)"
        fill="#c4f24a"
      />
      <path
        d="M0 0 C 10 -19.2 7.2 -51.2 0 -64 C -7.2 -51.2 -10 -19.2 0 0 Z"
        transform="translate(100 150) rotate(-61)"
        fill="#c4f24a"
      />
      <path
        d="M0 0 C 6 -14.1 4.32 -37.6 0 -47 C -4.32 -37.6 -6 -14.1 0 0 Z"
        transform="translate(100 150) rotate(89)"
        fill="#c4f24a"
      />
      <path
        d="M0 0 C 6 -14.1 4.32 -37.6 0 -47 C -4.32 -37.6 -6 -14.1 0 0 Z"
        transform="translate(100 150) rotate(-89)"
        fill="#c4f24a"
      />
    </svg>
  );
}
